/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Rail_TrainInputs */

const en_how_page_rail_train = /** @type {(inputs: How_Page_Rail_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train`)
};

const pl_how_page_rail_train = /** @type {(inputs: How_Page_Rail_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenuj`)
};

/**
* | output |
* | --- |
* | "Train" |
*
* @param {How_Page_Rail_TrainInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_rail_train = /** @type {((inputs?: How_Page_Rail_TrainInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Rail_TrainInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_rail_train(inputs)
	return en_how_page_rail_train(inputs)
});